export const cardStyle = {
  // border: "2px solid #1BA0F2",
  borderRight: "2px solid #1BA0F2",
  borderBottom: "2px solid #1BA0F2",
  boxShadow:
    "-5px -5px 8px #1BA0F2, -10px -10px 8px #38BDF2, -15px -15px 8px #38D0F2",
};
